import {useState, type ChangeEvent, type KeyboardEvent} from 'react'
// Layouts
import Section from './section'
// Utils
import comparePasswordToHash from '../../utils/compare-password-to-hash'
// Styles
import pageStyles from './page.module.scss'
import styles from './page-password-input.module.scss'

interface PagePasswordInputProps {
  ballotPassword: string
  sendHasEnteredCorrectPassword: (isCorrect: boolean) => void
}

const PagePasswordInput = ({
  ballotPassword,
  sendHasEnteredCorrectPassword,
}: PagePasswordInputProps) => {
  const [userEnteredPassword, setUserEnteredPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const handleSubmit = () => {
    const isValidPassword = comparePasswordToHash(userEnteredPassword, ballotPassword)
    if (isValidPassword) {
      setErrorMessage(null)
      sendHasEnteredCorrectPassword(true)
    } else {
      setErrorMessage('Incorrect ballot password')
      sendHasEnteredCorrectPassword(false)
    }
  }
  const handleKeyDown = ({key}: KeyboardEvent<HTMLInputElement>) => {
    if (key === 'Enter')
      handleSubmit()
  }
  const handlePasswordInputChange = (syntheticEvent: ChangeEvent<HTMLInputElement>) => {
    setErrorMessage(null)
    setUserEnteredPassword(syntheticEvent.target.value)
  }

  return (
    <div className={pageStyles['page']}>
      {/* Password input */}
      <Section
        styleModifiers={[
          '--is-flex-column',
          '--is-centered-vertically',
          '--is-centered-horizontally',
          '--is-full-height',
        ]}
      >
        <h2 className={styles['__error-message']}>{errorMessage}</h2>
        <input
          type="password"
          placeholder="Please enter the ballot password"
          onChange={handlePasswordInputChange}
          className={styles.passwordInput}
          onKeyDown={handleKeyDown}
        />
        <div className='buttons'>
          <input
            type="button"
            value="View ballot now"
            onClick={handleSubmit}
            disabled={!userEnteredPassword}
            className='button is-large is-dark'
          />
        </div>
      </Section>
    </div>
  )
}

export default PagePasswordInput
